import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { alpha } from "@mui/material/styles";
import { Typography, IconButton, Stack, Button } from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { StyledMenu, StyledMenuItem } from "./AccountPopover.styles";
import { StyledIconBtn } from "../../configs/GoStyles";
import AuthContext from "../../store/auth-context";
import PasswordChange from "../../pages/auth/PasswordChange/PasswordChange";

const AccountPopover = () => {
    const [open, setOpen] = useState(false);

    const navigate = useNavigate();
    const authContext = useContext(AuthContext);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const logout = () => {
        authContext.logout();
        sessionStorage.clear();
        navigate("/");
    };

    return (
        <React.Fragment>
            <StyledIconBtn onClick={handleMenuOpen}>
                <AccountCircle />
            </StyledIconBtn>
            <StyledMenu
                id="menu-appbar"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
            >
                <Stack sx={{ p: 1 }}>
                    <StyledMenuItem onClick={() => setOpen(true)}>
                        <Typography variant="body1">Change Password</Typography>
                    </StyledMenuItem>
                    <StyledMenuItem onClick={logout}>
                        <Typography variant="body2">Logout</Typography>
                    </StyledMenuItem>
                </Stack>
            </StyledMenu>
            {open && <PasswordChange open={open} handleClose={(e: any) => setOpen(e)} />}
        </React.Fragment>
    );
};

export default AccountPopover;
